define('views/modules/questionnaire/questions/edit/question-edit-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'models/questionnaire/question',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/questionnaire/questions/edit/question-edit-content',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models
    MQuestion,
    // views
    VBasePanel,
    VQuestionEditContent
) {

    var VQuestionEditPanel = VBasePanel.extend({
        header: {
            title: "questionnaire:Question",
            subtitle: "questionnaire:Adding/Modify a question",
        },
        content: {
            edit: VQuestionEditContent
        },
        tabs: [{ id: 'edit', title: 'Edit', active: true }],
        defaultView: 'edit',

        initialize: function(opt) {
            opt = opt || {};
            this.model = new MQuestion();
            var edit = this.getView('edit', {
                model: this.model,
                questionnaire: opt.questionnaire,
                group: opt.group
            });
            this.listenTo(edit, {
                'form:success': this.close,
                'question:add': this.onAddQuestion
            });
        },

        setModel: function(model) {
            if (!model) return;
            var attrs = model.attributes || model;
            this.model.reset(attrs);
            return this;
        },

        resetModel: function(attrs, options) {
            this.model.reset(attrs, options);
            return this;
        },

        onAddQuestion: function() {
            this.close();
            this.trigger('question:add');
        },

    });

    return VQuestionEditPanel;

});

